// @ts-nocheck

import React, { useCallback, useState } from 'react';
import styled, { css } from 'styled-components';

import { ArrowLightSvg, OptionSvg } from '../../../../assets/svg/history';
import CollapseListItem from '../../../../components/CollapseListItem';
import { __ } from '../../../../i18n/l10n';
import colors from '../../../../styled-components/palette';
import BetslipOptionsItemClick from '../BetslipOptionsItem/BetslipOptionsItemClick';
import BetslipOptionsItemSwitch from '../BetslipOptionsItem/BetslipOptionsItemSwitch';

const Wrapper = styled.div`
  position: relative;

  &::before {
    content: '';
    background-color: ${colors.bluegrey800};
    position: absolute;
    left: 3em;
    right: 0.5em;
    height: 1px;
    top: 0;
    z-index: 1;
  }
`;

const StyledBetslipOptionsItemClick = styled(BetslipOptionsItemClick)`
  ${({ $isBackgroundActive }) =>
    $isBackgroundActive
      ? css`
          &&& {
            background-color: ${colors.bluegrey850};
          }
        `
      : null}
`;

const StyledBetslipOptionsItemSwitch = styled(BetslipOptionsItemSwitch)`
  &&& {
    background-color: ${colors.bluegrey850};
  }
`;

const Content = styled.div`
  padding: 0 0.5em 0 2.5em;
  background-color: ${colors.bluegrey850};
`;

const ArrowIcon = styled.div`
  width: 1em;
  height: 1em;
  transition: transform 0.3s ease-in-out;

  ${({ $rotateIcon }) =>
    $rotateIcon
      ? css`
          transform: rotate(-180deg);
        `
      : null}
`;

type BetslipOptionsShareSettingsItemProps = {
  className?: string;
  onToggleImagePseudo: () => void;
  isImagePseudoToggled: boolean;
  onToggleImageStack: () => void;
  isImageStackToggled: boolean;
};

const BetslipOptionsShareSettingsItem = ({
  className = '',
  onToggleImagePseudo,
  isImagePseudoToggled,
  onToggleImageStack,
  isImageStackToggled,
}: BetslipOptionsShareSettingsItemProps) => {
  const [showSetting, setShowSetting] = useState(false);

  const handleToggleSettings = useCallback(() => {
    setShowSetting((previous) => !previous);
  }, []);

  return (
    <Wrapper $isBackgroundActive={showSetting}>
      <StyledBetslipOptionsItemClick
        className={className}
        label={__('Share options')}
        icon={<OptionSvg />}
        rightIcon={
          <ArrowIcon $rotateIcon={showSetting}>
            <ArrowLightSvg />
          </ArrowIcon>
        }
        onClick={handleToggleSettings}
        $isBackgroundActive={showSetting}
      />

      <CollapseListItem isOpened={showSetting}>
        <Content>
          <StyledBetslipOptionsItemSwitch
            label={__('Show username')}
            onToggle={onToggleImagePseudo}
            isToggled={isImagePseudoToggled}
            $isBackgroundActive={showSetting}
          />
          <StyledBetslipOptionsItemSwitch
            label={__('Show wager and winnings')}
            onToggle={onToggleImageStack}
            isToggled={isImageStackToggled}
            $isBackgroundActive={showSetting}
          />
        </Content>
      </CollapseListItem>
    </Wrapper>
  );
};

export default BetslipOptionsShareSettingsItem;
